<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>
    <div
      class="dz-bnr-inr dz-bnr-inr-sm"
      style="
        background-image: url(/assets/images/teacher-resources/banner.png);
        background-size: cover;
        background-position: left;
      "
    >
      <div class="container">
        <div class="dz-bnr-inr-entry text-left">
          <!-- <h1 class="text-left text-primary">About Us</h1> -->
          <!--<nav aria-label="breadcrumb" class="breadcrumb-row m-t15">
             <ul class="breadcrumb">
               <li class="breadcrumb-item"><a href="index.html">Home</a></li>
               <li class="breadcrumb-item active" aria-current="page">
                 About Us
               </li>
             </ul>
           </nav> -->
        </div>
      </div>
    </div>
    <br />
    <!-- <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/teacher-resources/body1.png);
        background-size: cover;
        background-position: center;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dz-bnr-inr-entry"
              style="
                background-color: rgba(
                  255,
                  255,
                  255,
                  0.8
                ); /* White with 80% opacity */
                padding: 20px 50px 50px;
                border-radius: 10px;
                color: black;
                height: 200px;
              "
            >
              <br />
              <p class="text-primary" style="font-weight: 400">
                {{pageContent.banner_header}}<br />{{pageContent.banner_subtext}}<br /><br />{{pageContent.banner_paragraph}}
              </p>
            </div>
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-6 col-md-3 mb-2">
            <a href="javascript:void(0);" @click="showTemplatesModal = true">
              <img
                src="assets/images/teacher-resources/1.png"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </a>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <router-link to="/classroom-management">
              <img
                src="assets/images/teacher-resources/2.png"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </router-link>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <router-link to="/online-courses">
              <img
                src="assets/images/teacher-resources/3.png"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </router-link>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <a href="javascript:void(0);" @click="showSmartToolsModal = true">
              <img
                src="assets/images/teacher-resources/4.png"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="text-primary" style="font-weight: 500">
            Everything You Need, All in One Place
          </h2>
          <hr class="hr" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="text-primary">
            From lesson planning and classroom management to professional
            development and data tracking, our teacher resources are built to
            support every aspect of your teaching journey. Discover practical
            tools, proven strategies, and inspiring content that help you plan
            with purpose, teach with confidence, and grow every step of the way.
          </p>
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-7 col-xl-7">
          <div class="row">
            <div class="col-md-4">
              <div
                class="grid"
                @click="goToLink('assessment-and-data-tracking')"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/teacher_resources/1.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Track student growth and make data-driven decisions with
                      ease.
                    </p>
                  </figcaption>
                </figure>
                <a
                  href="/assessment-and-data-tracking"
                  class="text-primary text-center h6"
                  >Assessment & Data Tracking</a
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="grid" @click="goToLink('classroom-management')">
                <figure class="effect-zoe classroom-hover" >
                  <img
                    src="assets/images/teacher_resources/2.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Tools and resources to support structure, engagement, and
                      a positive classroom climate.
                    </p>
                  </figcaption>
                </figure>
                <a
                  href="/classroom-management"
                  class="text-primary text-center h6"
                  >Classroom Management</a
                >
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="grid"
                @click="goToLink('lesson-planning-and-curriculum-resources')"
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/teacher_resources/3.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Quick access to standards-aligned lessons and creative
                      planning tools.
                    </p>
                  </figcaption>
                </figure>
                <a
                  href="/lesson-planning-and-curriculum-resources"
                  class="text-primary text-center h6"
                  >Lesson Planning & Curriculum Resources</a
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="grid" @click="goToLink('online-courses')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/teacher_resources/4.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Grow your skills with curated workshops, webinars, and
                      resources.
                    </p>
                  </figcaption>
                </figure>
                <a href="/online-courses" class="text-primary text-center h6"
                  >Professional Development</a
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="grid" @click="goToLink('tech-integration')">
                <figure class="effect-zoe">
                  <img
                    src="assets/images/teacher_resources/5.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Enhance learning through interactive and efficient digital
                      tools.
                    </p>
                  </figcaption>
                </figure>
                <a href="/tech-integration" class="text-primary text-center h6"
                  >Tech Integration Tools</a
                >
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="grid"
                @click="
                  goToLink('social-learning-resources')
                "
              >
                <figure class="effect-zoe">
                  <img
                    src="assets/images/teacher_resources/6.png"
                    alt="chase"
                    class="img-fluid rounded"
                  />
                  <figcaption>
                    <p class="description">
                      Foster equity and belonging with inclusive teaching
                      strategies.
                    </p>
                  </figcaption>
                </figure>
                <a
                  href="/social-learning-resources"
                  class="text-primary text-center h6"
                  >Social Learning Resources</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-xl-5">
          <div
            class=""
            style="
              background-image: url('assets/images/teacher_resources/banner.png');
              min-height: 500px;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              border-radius: 0px;
            "
          ></div>
        </div>
      </div>
    </div>

    <br />
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/about/Body3.png);
        background-size: cover;
        background-position: center;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div
          class="dz-bnr-inr-entry"
          style="
            background-color: rgba(
              255,
              255,
              255,
              0.9
            ); /* White with 80% opacity */
            padding: 50px;
            border-radius: 10px;
            color: black;
          "
        >
          <br />
          <h2 class="text-primary" style="font-weight: 400">
            {{ pageContent.section_title }}
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <img
            src="/assets/images/Explore2Teach_Logo.png"
            class="img-fluid d-block mx-auto"
            alt=""
          />
          <div class="teaching-journey">
            <center>
              <router-link to="/contact-us">
                <button class="btn btn-primary">
                  {{ pageContent.contact_button }}
                </button>
              </router-link>
            </center>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
    <TeacherTemplatesModal
      :pageContent="templateContent"
      :show="showTemplatesModal"
      @close="showTemplatesModal = false"
    />
    <SmartToolsModal
      :pageContent="templateContent2"
      :show="showSmartToolsModal"
      @close="showSmartToolsModal = false"
    />
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<style scoped>
.grid {
  padding: 1em 0px 0px;
}
.teaching-journey {
  margin-top: -80px;
}

.hr {
  border: 1px solid #0d6efd;
  border-radius: 5px;
}

@media (max-width: 991px) {
  .teaching-journey {
    margin-top: -40px;
  }
}

@media (max-width: 767px) {
  .teaching-journey {
    margin-top: -20px;
  }
}

/*---------------*/
/***** Zoe *****/
/*---------------*/

figure.effect-zoe figcaption {
  top: auto;
  bottom: auto;
  padding: 1em;
  height: 4em;
  color: #3c4a50;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

figure.classroom-hover figcaption {
  top: auto;
  bottom: auto;
  padding: 1em;
  height: 6em !important;
  color: #3c4a50;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}



figure.effect-zoe h2 {
  float: left;
}

figure.effect-zoe p.icon-links a {
  float: right;
  color: #3c4a50;
  font-size: 1.4em;
}

figure.effect-zoe:hover p.icon-links a:hover,
figure.effect-zoe:hover p.icon-links a:focus {
  color: #252d31;
}

figure.effect-zoe p.description {
  position: absolute;
  bottom: 6em;
  padding: 2em;
  color: #fff;
  background: #2881f4;
  text-transform: none;
  left: 0;
  font-size: 90%;
  opacity: 0;
  -webkit-transition: opacity 0.35s;
  transition: opacity 0.35s;
  -webkit-backface-visibility: hidden;
  /* Fix for Chrome 37.0.2062.120 (Mac) */
}

figure.effect-zoe h2,
figure.effect-zoe p.icon-links a {
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(0, 200%, 0);
  transform: translate3d(0, 200%, 0);
}

figure.effect-zoe p.icon-links a span::before {
  display: inline-block;
  padding: 8px 10px;
  font-family: "feathericons";
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-eye::before {
  content: "\e000";
}

.icon-paper-clip::before {
  content: "\e001";
}

.icon-heart::before {
  content: "\e024";
}

figure.effect-zoe h2 {
  display: inline-block;
}

figure.effect-zoe:hover p.description {
  opacity: 1;
}

figure.effect-zoe:hover figcaption,
figure.effect-zoe:hover h2,
figure.effect-zoe:hover p.icon-links a {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-zoe:hover h2 {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(3) {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

figure.effect-zoe:hover p.icon-links a:nth-child(2) {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

figure.effect-zoe:hover p.icon-links a:first-child {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
</style>

<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import TeacherTemplatesModal from "@/components/TeacherTemplatesModal.vue";
import SmartToolsModal from "@/components/SmartToolsModal.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
    TeacherTemplatesModal,
    SmartToolsModal,
  },
  data() {
    return {
      showTemplatesModal: false,
      showSmartToolsModal: false,
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
      templateContent: [],
      templateContent2: [],
    };
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    goToLink(link) {
      // window.open(`https://${link}`, "_blank");
      window.location = `/${link}`;
    },
    getFileName(url) {
      const decodedURL = decodeURIComponent(url);
      return decodedURL.split("/").pop().split("?")[0];
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.teacher_resource[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      const templateContent = globalMixins.teacher_template_modal[lang];
      const templateContent2 = globalMixins.smart_tools[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.templateContent = {
          ...this.templateContent,
          ...templateContent,
        };
        this.templateContent2 = {
          ...this.templateContent2,
          ...templateContent2,
        };
        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };

        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>